import React, { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as UnosKorisnika } from "../../assets/svg/Administracija/UnosKorisnika.svg";
import { ReactComponent as UpravljanjeKorisnicima } from "../../assets/svg/Administracija/UpravljanjeKorisnicima.svg";
import { ReactComponent as AdministracijaKorisnika } from "../../assets/svg/Administracija/AdministracijaKorisnika.svg";
import { ReactComponent as AdministracijaInstitucija } from "../../assets/svg/Administracija/AdministracijaInstitucija.svg";
import { ReactComponent as UnosInstitucije } from "../../assets/svg/Administracija/UnosInstitucije.svg";
import { ReactComponent as UpravljanjeInstitucijama } from "../../assets/svg/Administracija/UpravljanjeInstitucijama.svg";
import { ReactComponent as PromenaNadleznosti } from "../../assets/svg/Administracija/PromenaNadleznosti.svg";
import { ReactComponent as SluzbeniGlasnik } from "../../assets/svg/Administracija/SluzbeniGlasnik.svg";
import { ReactComponent as UnosSluzbenogGlasnika } from "../../assets/svg/Administracija/UnosSluzbenogGlasnika.svg";
import { ReactComponent as UpravljanjeSluzbenogGlasnika } from "../../assets/svg/Administracija/UpravljanjeSluzbenogGlasnika.svg";
import { ReactComponent as UnosDatumaSG } from "../../assets/svg/Administracija/UnosDatumaSG.svg";
import { ReactComponent as UpravljanjeDatumaSG } from "../../assets/svg/Administracija/UpravljanjeDatumaSG.svg";
import { ReactComponent as MedjunarodnaKonvencija } from "../../assets/svg/Administracija/MedjunarodnaKonvencija.svg";
import { ReactComponent as UnosMedjunarodneKonvencije } from "../../assets/svg/Administracija/UnosMedjunarodneKonvencije.svg";
import { ReactComponent as UpravljanjeMedjunarodnimKonvencijama } from "../../assets/svg/Administracija/UpravljanjeMedjunarodnimKonvencijama.svg";
import { ReactComponent as TabeleUskladjenosti } from "../../assets/svg/Administracija/TabeleUskladjenosti.svg";
import { ReactComponent as UvozEUPropisa } from "../../assets/svg/Administracija/UvozEUPropisa.svg";
import { ReactComponent as KonfiguracijaZakljucavanja } from "../../assets/svg/Administracija/KonfiguracijaZakljucavanja.svg";
import { ReactComponent as Parametrizacija } from "../../assets/svg/Administracija/Parametrizacija.svg";
import { ReactComponent as Help } from "../../assets/svg/Administracija/Help.svg";
import { ReactComponent as FileConfing } from "../../assets/svg/Administracija/fileConfig.svg";
import Sidebar from "../SideBar";
import ReportingConfig from "./screens/ReportingConfig";

function Administration() {
  const menuList = [
    {
      name: "Администрирање корисника",
      icon: <AdministracijaKorisnika />,
      subMenus: [
        {
          name: "insertUser",
          title: "Унос корисника",
          url: "/administration/user/insert",
          icon: <UnosKorisnika />,
        },
        {
          name: "userManagement",
          title: "Управљање корисницима",
          url: "/administration/user/management",
          select: "user/edit",
          icon: <UpravljanjeKorisnicima />,
        },
      ],
    },
    {
      name: "Администрирање институција",
      icon: <AdministracijaInstitucija />,
      subMenus: [
        {
          name: "insertInstitution",
          title: "Унос институције",
          url: "/administration/institution/insert",
          icon: <UnosInstitucije />,
        },
        {
          name: "institutionManagement",
          title: "Управљање институцијама",
          url: "/administration/institution/management",
          icon: <UpravljanjeInstitucijama />,
        },
        {
          name: "changeInstitution",
          title: "Промена надлежности",
          url: "/administration/institution/change",
          icon: <PromenaNadleznosti />,
        },
      ],
    },
    {
      name: "Службени гласник",
      icon: <SluzbeniGlasnik />,
      subMenus: [
        {
          name: "insertOJ",
          title: "Унос сл. гласника",
          url: "/administration/oj/insert",
          icon: <UnosSluzbenogGlasnika />,
        },
        {
          name: "OJManagement",
          title: "Управљање сл. гласника",
          url: "/administration/oj/management",
          icon: <UpravljanjeSluzbenogGlasnika />,
        },
        {
          name: "ojDateInsert",
          title: "Унос датума објаве СГ",
          url: "/administration/oj/date/insert",
          icon: <UnosDatumaSG />,
        },
        {
          name: "ojDateManagement",
          title: "Управљање датумом објаве СГИ",
          url: "/administration/oj/date/management",
          icon: <UpravljanjeDatumaSG />,
        },
      ],
    },
    {
      name: "Међународне конвенције без броја",
      icon: <MedjunarodnaKonvencija />,
      subMenus: [
        {
          name: "intconvInsert",
          title: "Унос међународне конвенције",
          url: "/administration/intconv/insert",
          icon: <UnosMedjunarodneKonvencije />,
        },
        {
          name: "intconvManagement",
          title: "Управљање међународним конвенцијама",
          url: "/administration/intconv/management",
          icon: <UpravljanjeMedjunarodnimKonvencijama />,
        },
      ],
    },
    {
      name: "Остало",
      subMenus: [
        {
          name: "tuManagement",
          title: "Табеле усклађености",
          url: "/administration/tu/management",
          icon: <TabeleUskladjenosti />,
        },
        {
          name: "euInsert",
          title: "Увоз ЕУ прописа",
          url: "/administration/eu/insert",
          icon: <UvozEUPropisa />,
        },
        {
          name: "parameters",
          title: "Параметризација",
          url: "/administration/parameters",
          icon: <Parametrizacija />,
        },
        {
          name: "locking",
          title: "Конфигурација закључавања",
          url: "/administration/locking",
          icon: <KonfiguracijaZakljucavanja />,
        },
        {
          name: "reporting",
          title: "Конфигурација извештавања",
          url: "/administration/reporting",
          icon: <FileConfing />,
        },
        {
          name: "help",
          title: "Упутства",
          url: "/help",
          icon: <Help />,
        },
      ],
    },
  ];

  return (
    <div className="w-full h-full flex flex-row relative ">
      {/* SIDEBAR */}
      <Sidebar menuList={menuList} />

      {/* OUTLET */}
      <div className="flex-1 w-full overflow-y-scroll gray-small-scroll transition-all duration-300">
        <Outlet />
      </div>
    </div>
  );
}

export default Administration;
